const isWeb = true;
const isMRN = false;
import { getScreenSize, getSafeAreaMarginTop, getSafeAreaMarginBottom } from "@max/meituan-uni-screenInfo";
export function toUnit(value) {
    return isMRN ? `${value}rpx` : `${value}px`;
}
export function getFullScreenSize(defaultHeightInRpx = '1624rpx') {
    const layoutInfo = {
        fullScreenWidth: '750rpx',
        fullScreenHeight: defaultHeightInRpx,
        safeAreaMarginTop: 0,
        safeAreaMarginBottom: 0,
        isTinySizeDevice: false,
        width: 0,
        height: 0,
        rateWidth: 750,
        rateHeight: 1624,
        toRateSize: (num) => num,
        rateSafeAreaMarginBottom: 0,
        rateSafeAreaMarginTop: 0
    };
    try {
        const { height, width } = getScreenSize();
        layoutInfo.width = width;
        layoutInfo.height = height;
        const toRateSize = (num) => {
            return num * width / 750;
        };
        layoutInfo.toRateSize = toRateSize;
        const rateHeight = height * (750 / width);
        layoutInfo.rateHeight = rateHeight;
        if (rateHeight < 1570) {
            layoutInfo.isTinySizeDevice = true;
        }
        if (isMRN) {
            layoutInfo.fullScreenHeight = `${rateHeight}rpx`;
        }
        else if (true) {
            layoutInfo.fullScreenWidth = `${width}px`;
            layoutInfo.fullScreenHeight = `${height}px`;
        }
        const safeAreaMarginTop = getSafeAreaMarginTop();
        const safeAreaMarginBottom = getSafeAreaMarginBottom();
        layoutInfo.safeAreaMarginTop = safeAreaMarginTop;
        layoutInfo.safeAreaMarginBottom = safeAreaMarginBottom;
        layoutInfo.rateSafeAreaMarginBottom = toRateSize(safeAreaMarginBottom);
        layoutInfo.rateSafeAreaMarginTop = toRateSize(safeAreaMarginTop);
    }
    catch (e) { }
    return layoutInfo;
}
